import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { openErrorMessage } from '../../../actions/message'
import { LoyaltyProviderContainer } from './LoyaltyProvidersContainer'
import { GrowthTile } from '../../../components/GrowthTile'

// actions
import { getCompany, updateCompany } from '../../../actions/company'
import { startLoading, stopLoading } from '../../../actions/loading'

// local components
import LoyaltyRewards from '../../../components/LoyaltyRewards'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import EditableHOCWrapper from '../../HOC/EditableHOC'

import { monolithIsFeatureFlagEnable } from '../../../api/unleash'
import { UnleashToggles } from '../../../types/unleashToggles'

const LoyaltyRewardsEditable = EditableHOCWrapper(LoyaltyRewards)

class LoyaltyRewardsContainer extends PureComponent {
  state = {
    hasActiveProvider: false,
    companyLoaded: false,
    isLoyaltyServiceEnabled: false,
  }
  componentDidMount() {
    this.props.dispatch(getCompany()).then(() => {
      this.setState({ companyLoaded: true })
    })
    monolithIsFeatureFlagEnable(UnleashToggles.LOYALTY_SERVICE).then((res) => {
      this.setState({ isLoyaltyServiceEnabled: res })
    })
  }

  onProvidersChange = (hasActive) => {
    this.setState({ hasActiveProvider: hasActive })
  }

  onSave = (data, afterOnSave) => {
    if (this.state.hasActiveProvider && data.enableLoyalty) {
      this.props.dispatch(openErrorMessage('A loyalty provider is already enabled.'))
      return
    }
    this.props.dispatch(startLoading())

    this.props.dispatch(updateCompany(data)).then((response) => {
      afterOnSave(response)
      this.props.dispatch(stopLoading())
    })
  }

  render() {
    const { company = {}, lastModified = null } = this.props.companyReducer
    return (
      <>
        <LoyaltyRewardsEditable
          dataToEdit={company}
          onSave={this.onSave}
          lastModified={lastModified}
          growthTile={
            this.state.companyLoaded &&
            this.state.isLoyaltyServiceEnabled && <GrowthTile disabled={company.enableLoyalty} />
          }
        />
        {this.state.companyLoaded && this.state.isLoyaltyServiceEnabled && company.name && (
          <div style={{ marginTop: 24 }}>
            <LoyaltyProviderContainer
              disabled={company.enableLoyalty}
              onProvidersChange={this.onProvidersChange}
              tenantName={company.name}
            />
          </div>
        )}
      </>
    )
  }
}

const LoyaltyRewardsWithTitle = ContainerWithTitle(LoyaltyRewardsContainer, 'Loyalty Rewards')
const LoyaltyRewardsConnected = connect(({ dispatch, companyReducer }) => ({
  dispatch,
  companyReducer,
}))(LoyaltyRewardsWithTitle)

export default LoyaltyRewardsConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/LoyaltyRewards.js